/**
 * 生产排班
 */
import http from '@/http'

export default {
  // 查询时间段排班列表
  getScheduleList(params) {
    return http.get('/production/schedule', { params })
  },
  // 保存排班
  saveSchedule(params) {
    return http.post('/production/schedule', params)
  },
  // 删除单个排班
  delSchedule(params) {
    return http.post('/production/schedule/delete', params)
  },
  // 批量删除排班
  batchDelSchedule(params) {
    return http.post('/production/schedule/batch-delete', params)
  }
}
